import React from "react";
import {css} from "@emotion/react";

import {PlayIcon} from "@pg-design/icons-module";

export const ReelPlayButtonCover = () => {
    return (
        <div css={playCoverStyle}>
            <PlayIcon size="3" wrapperSize="4.8" wrapperType="circle" wrapperColor="#fff" />
        </div>
    );
};

const playCoverStyle = css`
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
`;
import React from "react";
import {css} from "@emotion/react";

import {PlayIcon} from "@pg-design/icons-module";

export const ReelPlayButtonCover = () => {
    return (
        <div css={playCoverStyle}>
            <PlayIcon size="3" wrapperSize="4.8" wrapperType="circle" wrapperColor="#fff" />
        </div>
    );
};

const playCoverStyle = css`
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
`;
